var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"py-5 mb-5 mt-5 d-flex justify-content-center custom-container"},[(_vm.currentRoute === 'email')?_c('change-email-form'):(_vm.currentRoute === 'phone_number')?_c('change-phone-form'):(_vm.currentRoute === 'password')?_c('change-password-form'):(_vm.currentRoute === 'account')?_c('delete-account-form'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }